import React, { createContext, useContext, useState } from 'react';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 5000); // Hide loader after 5 seconds
  };

  return (
    <LoaderContext.Provider value={{ isLoading, showLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};


export const useLoader = () => useContext(LoaderContext);
